var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"holding-lichess-tournament"},[_c('TournamentModeration',{attrs:{"tournament":_vm.tournament},on:{"update":_vm.updateTournament}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }